// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import {application} from "./application"
import {TomSelectController} from "./tom_select_controller";
import FlatpickrController from "./flatpickr_controller";
import {TournamentAPNController} from "./tournament_apn_controller";
import {BannerController} from "./banner_controller";
import {BootstrapTurboModalController} from "./bootstrap_turbo_modal_controller";
import {BootstrapTurboController} from "./bootstrap_toast_controller";
import {EligiblePlayersController} from "./eligible_players_controller";

application.register("tom-select", TomSelectController)
application.register("flatpickr", FlatpickrController)
application.register("bootstrap-turbo-modal", BootstrapTurboModalController)
application.register("bootstrap-toast", BootstrapTurboController)
application.register("tournament-apn", TournamentAPNController)
application.register("banner", BannerController)
application.register("eligible-players", EligiblePlayersController)
